import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { lookupOrder } from '../api/orders';
import { useShop } from './ShopState';

/**
 * Recovery form for a buyer who no longer has their order link. The order id
 * alone is guessable, so the surname is the second factor.
 */
export function OrderLookupForm({ compact = false }: { compact?: boolean }) {
  const navigate = useNavigate();
  const { setLastOrder } = useShop();
  const [orderId, setOrderId] = useState('');
  const [surname, setSurname] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const found = await lookupOrder(orderId.trim(), surname.trim());
      setLastOrder({ id: found.id, token: found.accessToken });
      navigate(`/zamowienie/${found.id}?t=${encodeURIComponent(found.accessToken)}`);
    } catch {
      // The API answers 404 for a wrong id and a wrong surname alike.
      setError('Nie znaleźliśmy zamówienia o tych danych.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        textAlign: 'left',
        marginTop: compact ? 0 : 28,
      }}
    >
      <div className="display" style={{ fontSize: 12, letterSpacing: '.14em', color: 'var(--orange)' }}>
        ZNAJDŹ ZAMÓWIENIE
      </div>
      <input
        className="input mono"
        placeholder="Numer zamówienia (OPT-26-…)"
        value={orderId}
        onChange={(e) => setOrderId(e.target.value)}
        autoComplete="off"
        required
      />
      <input
        className="input"
        placeholder="Nazwisko"
        value={surname}
        onChange={(e) => setSurname(e.target.value)}
        autoComplete="family-name"
        required
      />
      {error && (
        <div style={{ color: '#E07C5A', fontSize: 12 }} role="alert">
          {error}
        </div>
      )}
      <button className="btn full" type="submit" disabled={submitting}>
        {submitting ? 'Szukam…' : 'Sprawdź status'}
      </button>
    </form>
  );
}
